/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Connections_Modular_Connect_ButtonInputs */



/**
* | output |
* | --- |
* | "Connect {name}" |
*
* @param {Connections_Modular_Connect_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const connections_modular_connect_button = /** @type {((inputs: Connections_Modular_Connect_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connections_Modular_Connect_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.name} verbinden`)
	return /** @type {LocalizedString} */ (`Connect ${i?.name}`)
});